import Marquee from "react-fast-marquee";
import { CLIENTS } from "@/lib/content";
import { clientLogo } from "@/lib/assets";

export default function ClientsStrip() {
  const half = Math.ceil(CLIENTS.length / 2);
  const row1 = CLIENTS.slice(0, half);
  const row2 = CLIENTS.slice(half);

  const LogoItem = ({ c }) => (
    <div
      key={c.slug}
      data-testid={`client-logo-${c.slug}`}
      className="group mx-8 md:mx-10 h-16 md:h-14 lg:h-16 flex items-center justify-center px-2"
    >
      <img
        src={clientLogo(c.slug)}
        alt={c.name}
        className="max-h-12 md:max-h-14 lg:max-h-16 w-auto object-contain transition-transform duration-500 group-hover:scale-[1.03]"
        loading="lazy"
        decoding="async"
      />
    </div>
  );

  return (
    <section id="clients" data-testid="clients-section" className="relative bg-offwhite py-20 md:py-28 border-y border-softgray">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 mb-12 md:mb-14">
        <div className="text-center max-w-3xl mx-auto">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="gold-hairline" />
            <span className="text-gold text-xs uppercase tracking-[0.28em] font-medium">Our Clients</span>
            <span className="gold-hairline" />
          </div>
          <h2 className="font-serif text-navy text-3xl md:text-4xl lg:text-5xl font-light leading-[1.1] tracking-[-0.01em]">
            Trusted by <em className="text-gold not-italic">leading</em> organizations.
          </h2>
          <p className="text-mutedink text-sm md:text-base mt-6 font-light max-w-2xl mx-auto leading-relaxed">
            Supporting respected local and international organizations across aviation, banking, education, professional services, construction, security, and travel.
          </p>
        </div>
      </div>

      <div className="marquee-mask space-y-6 md:space-y-8">
        <Marquee gradient={false} speed={32} pauseOnHover>
          {row1.map((c) => <LogoItem key={c.slug} c={c} />)}
        </Marquee>
        <Marquee gradient={false} speed={28} direction="right" pauseOnHover>
          {row2.map((c) => <LogoItem key={c.slug} c={c} />)}
        </Marquee>
      </div>

      {/* SEO fallback: all client names accessible */}
      <div className="sr-only">
        <ul>{CLIENTS.map((c) => <li key={c.slug}>{c.name}</li>)}</ul>
      </div>
    </section>
  );
}
